import './styles/global.scss';
import { createApp } from 'vue';
// eslint-disable-next-line import/no-unresolved
import { createPinia } from 'pinia';

import App from './App.vue';
import router from './router/router.js';
import { sentry } from './modules/sentry.js';

/* eslint-disable no-unused-vars */
import * as registerComponents from './modules/registerComponents.js';
import * as registerIcons from './modules/registerIcons.js';
/* eslint-enable no-unused-vars */

// Set up pinia
const pinia = createPinia();

const app = createApp(App);

app.use(router);
app.use(pinia);

// Initialize sentry
sentry(app);

app.mount('#app');
